export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960, // Sidebar permanent breakpoint
    lg: 1280,
    xl: 1920,
  },
};